import { JSX } from 'solid-js';
import { useProjectDataPanel } from '@trimble/project-data-panel-ui';
import TrajectorySelectionTreeContainer from '../TrajectorySelectionTreeContainer';
import { ProjectDataTreeContainerProps } from './shared-panel.types';
import { TrajectoryItem } from '@mobile-mapping/providers';

export type SharedTrajectoryTreeContainerProps =
  ProjectDataTreeContainerProps<TrajectoryItem>;

export const SharedTrajectoryTreeContainer = (
  props: SharedTrajectoryTreeContainerProps
): JSX.Element => {
  const { filterText, sortBy, sortDirection, filterMode } =
    useProjectDataPanel();

  return (
    <TrajectorySelectionTreeContainer
      nodes={props.nodes}
      childrenLoadStatus={props.childrenLoadStatus}
      defaultExpandIds={props.defaultExpandIds}
      filterKey={props.filterKey}
      filterText={props.nodes === undefined ? filterText() : undefined}
      highlightText={props.highlightText}
      sortBy={sortBy()}
      sortDirection={sortDirection()}
      filterMode={filterMode()}
    />
  );
};
